import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { 
  RelationalColors,
  RelationalColorDetails,
  EditRelationalColor
} from '@screens';

export type RelationalColorsStackParamList = {
  RelationalColorsList: undefined;
  RelationalColorDetails: { relationalColorId: string };
  EditRelationalColor: { relationalColorId: string };
};

const Stack = createNativeStackNavigator<RelationalColorsStackParamList>();

const RelationalColorsStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen 
        name="RelationalColorsList" 
        component={RelationalColors} 
      />
      <Stack.Screen 
        name="RelationalColorDetails" 
        component={RelationalColorDetails} 
      />
      <Stack.Screen 
        name="EditRelationalColor" 
        component={EditRelationalColor} 
      />
    </Stack.Navigator>
  );
};

export default RelationalColorsStackNavigator; 